const balanceAddress = "0xaF489a41e001dDeaFeC79829df5D56CC4b3a9Aa5" //Contract Address
export default balanceAddress;